/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var InfoSquareIcon16Regular = forwardRef('InfoSquareIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M9 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" }),
        React.createElement("path", { d: "M7.268 6.945a.75.75 0 1 0 0 1.5h.25v2.043H7a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5h-.482V7.695a.75.75 0 0 0-.75-.75h-1Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.25 4.5A3.25 3.25 0 0 1 4.5 1.25h7a3.25 3.25 0 0 1 3.25 3.25v7a3.25 3.25 0 0 1-3.25 3.25h-7a3.25 3.25 0 0 1-3.25-3.25v-7ZM4.5 2.75A1.75 1.75 0 0 0 2.75 4.5v7c0 .966.784 1.75 1.75 1.75h7a1.75 1.75 0 0 0 1.75-1.75v-7a1.75 1.75 0 0 0-1.75-1.75h-7Z" })));
});
